import {StreamType} from '@/types/stream-type';
import {EventPublicType} from '@/types/event-public-type';
import {InitiatorClass} from '@/types/InitiatorClass';
import moment from 'moment';
import {v4 as uuidv4} from 'uuid';
import {TicketCategory} from '@/types/ticket-category';
import {MarkedForDeletion} from '@/types/marked-for-deletion';

export class EventType {
  constructor(
    public id: string = uuidv4(),
    public title: string = '',
    public thumb: string = '',
    public desc: string = '',
    public tsStart: string = moment().hour(12).minute(0).add(1, 'days').toISOString(),
    public tsEnd: string = moment().hour(13).minute(0).add(1, 'days').toISOString(),
    public streamType = StreamType[0].value,
    public publicType = EventPublicType.PRIVATE,
    public markedForDeletion = MarkedForDeletion.NO,
    public  ticketNum?: number,
    public  initiator?: InitiatorClass,
    public  ticketCategory?: TicketCategory[]
  ) {
  }
}

